export default __webpack_public_path__ + "static/media/AIESC_Logo_Horizontal_PNG.cf5444e8.svg";